module.exports = __webpack_public_path__ + "static/img/lunboImg bg001.b3ea4080.jpg";